/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M21.8737 10.4063C21.1936 6.1599 17.8401 2.8064 13.5937 2.12631C13.1286 2.05181 12.8961 2.01457 12.6477 2.10809C12.45 2.18249 12.2364 2.36467 12.1316 2.54805C12 2.77854 12 3.05236 12 3.6V8.8C12 9.9201 12 10.4802 12.218 10.908C12.4097 11.2843 12.7157 11.5903 13.092 11.782C13.5198 12 14.0799 12 15.2 12H20.4C20.9476 12 21.2215 12 21.452 11.8684C21.6353 11.7636 21.8175 11.55 21.8919 11.3523C21.9854 11.1039 21.9482 10.8714 21.8737 10.4063Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 2.45801C4.94289 3.73227 2 7.52256 2 12.0002C2 17.5231 6.47715 22.0002 12 22.0002C16.4776 22.0002 20.2679 19.0573 21.5422 15.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M21.8737 10.4063C21.1936 6.1599 17.8401 2.8064 13.5937 2.12631C13.1286 2.05181 12.8961 2.01457 12.6477 2.10809C12.45 2.18249 12.2364 2.36467 12.1316 2.54805C12 2.77854 12 3.05236 12 3.6V8.8C12 9.9201 12 10.4802 12.218 10.908C12.4097 11.2843 12.7157 11.5903 13.092 11.782C13.5198 12 14.0799 12 15.2 12H20.4C20.9476 12 21.2215 12 21.452 11.8684C21.6353 11.7636 21.8175 11.55 21.8919 11.3523C21.9854 11.1039 21.9482 10.8714 21.8737 10.4063Z"
				fill="currentColor"
			/>
			<path
				d="M9 2.45801C4.94289 3.73227 2 7.52256 2 12.0002C2 17.5231 6.47715 22.0002 12 22.0002C16.4776 22.0002 20.2679 19.0573 21.5422 15.0002M15.2 12H20.4C20.9476 12 21.2215 12 21.452 11.8684C21.6353 11.7636 21.8175 11.55 21.8919 11.3523C21.9854 11.1039 21.9482 10.8714 21.8737 10.4063C21.1936 6.1599 17.8401 2.8064 13.5937 2.12631C13.1286 2.05181 12.8961 2.01457 12.6477 2.10809C12.45 2.18249 12.2364 2.36467 12.1316 2.54805C12 2.77854 12 3.05236 12 3.6V8.8C12 9.92011 12 10.4802 12.218 10.908C12.4097 11.2843 12.7157 11.5903 13.092 11.782C13.5198 12 14.0799 12 15.2 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M12.0508 1.27035C11.7847 1.25668 11.6517 1.24985 11.5392 1.30219C11.4434 1.34672 11.3574 1.4284 11.308 1.52173C11.25 1.63144 11.25 1.77096 11.25 2.05V7.95C11.25 9.63016 11.25 10.4702 11.577 11.112C11.8646 11.6765 12.3235 12.1354 12.888 12.423C13.5298 12.75 14.3698 12.75 16.05 12.75H21.95C22.2291 12.75 22.3687 12.75 22.4783 12.692C22.5716 12.6427 22.6532 12.557 22.6978 12.4613C22.7502 12.3489 22.7435 12.2156 22.7302 11.949C22.4059 5.46912 18.1263 1.58241 12.0508 1.27035Z"
				fill="currentColor"
			/>
			<path
				d="M9.75 2.45811C9.75 2.15147 9.75 1.99816 9.69606 1.89165C9.62414 1.74963 9.4889 1.65035 9.33186 1.62429C9.21408 1.60475 9.06781 1.65069 8.77526 1.74257C4.41455 3.11219 1.25 7.18571 1.25 12.0003C1.25 17.9374 6.06294 22.7503 12 22.7503C16.8146 22.7503 20.8881 19.5858 22.2577 15.225C22.3496 14.9325 22.3956 14.7862 22.376 14.6684C22.35 14.5114 22.2507 14.3762 22.1087 14.3042C22.0021 14.2503 21.8488 14.2503 21.5422 14.2503H16.15C13.9098 14.2503 12.7897 14.2503 11.934 13.8143C11.1814 13.4308 10.5695 12.8189 10.186 12.0663C9.75 11.2106 9.75 10.0905 9.75 7.8503V2.45811Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 9V9.5V9.5C12 9.96466 12 10.197 12.0384 10.3902C12.1962 11.1836 12.8164 11.8038 13.6098 11.9616C13.803 12 14.0353 12 14.5 12H20.4C20.9476 12 21.2215 12 21.452 11.8684C21.6353 11.7636 21.8175 11.55 21.8919 11.3523C21.9854 11.1039 21.9482 10.8714 21.8737 10.4063C21.1936 6.1599 17.8401 2.8064 13.5937 2.12631C13.1286 2.05181 12.8961 2.01457 12.6477 2.10809C12.45 2.18249 12.2364 2.36467 12.1316 2.54805C12 2.77854 12 3.05236 12 3.6V5M9 2.45801C4.94289 3.73227 2 7.52256 2 12.0002C2 17.5231 6.47715 22.0002 12 22.0002C16.4776 22.0002 20.2679 19.0573 21.5422 15.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 2.45801C4.94289 3.73227 2 7.52256 2 12.0002C2 17.5231 6.47715 22.0002 12 22.0002C16.4776 22.0002 20.2679 19.0573 21.5422 15.0002M15.2 12H20.4C20.9476 12 21.2215 12 21.452 11.8684C21.6353 11.7636 21.8175 11.55 21.8919 11.3523C21.9854 11.1039 21.9482 10.8714 21.8737 10.4063C21.1936 6.1599 17.8401 2.8064 13.5937 2.12631C13.1286 2.05181 12.8961 2.01457 12.6477 2.10809C12.45 2.18249 12.2364 2.36467 12.1316 2.54805C12 2.77854 12 3.05236 12 3.6V8.8C12 9.92011 12 10.4802 12.218 10.908C12.4097 11.2843 12.7157 11.5903 13.092 11.782C13.5198 12 14.0799 12 15.2 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.75 2.45821C9.75 2.15157 9.75 1.99826 9.69606 1.89175C9.62414 1.74973 9.4889 1.65045 9.33186 1.62439C9.21408 1.60485 9.06781 1.65079 8.77526 1.74267C4.41455 3.11229 1.25 7.18581 1.25 12.0004C1.25 17.9375 6.06294 22.7504 12 22.7504C16.8146 22.7504 20.8881 19.5859 22.2577 15.2251C22.3496 14.9326 22.3956 14.7863 22.376 14.6685C22.35 14.5115 22.2507 14.3763 22.1087 14.3043C22.0021 14.2504 21.8488 14.2504 21.5422 14.2504H16.15C13.9098 14.2504 12.7897 14.2504 11.934 13.8144C11.1814 13.4309 10.5695 12.819 10.186 12.0664C9.75 11.2107 9.75 10.0906 9.75 7.8504V2.45821Z"
				fill="currentColor"
			/>
			<path
				d="M12.0508 1.27035C11.7847 1.25668 11.6517 1.24985 11.5392 1.30219C11.4434 1.34672 11.3574 1.4284 11.308 1.52173C11.25 1.63144 11.25 1.77096 11.25 2.05V7.95C11.25 9.63016 11.25 10.4702 11.577 11.112C11.8646 11.6765 12.3235 12.1354 12.888 12.423C13.5298 12.75 14.3698 12.75 16.05 12.75H21.95C22.2291 12.75 22.3687 12.75 22.4783 12.692C22.5716 12.6427 22.6532 12.557 22.6978 12.4613C22.7502 12.3489 22.7435 12.2156 22.7302 11.949C22.4059 5.46912 18.1263 1.58241 12.0508 1.27035Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
